// helper function to allow only certain props for VAutoComplete component, for use with $attr and automatic bind

const props = {
  label: {
    type: String,
    default: undefined
  },
  hideDetails: {
    type: Boolean,
    default: false
  },
  singleLine: {
    type: Boolean,
    default: false
  },
  outlined: {
    type: Boolean,
    default: false
  },
  solo: {
    type: Boolean,
    default: false
  },
  loading: {
    type: Boolean,
    default: false
  },
  chips: {
    type: Boolean,
    default: false
  },
  deletableChips: {
    type: Boolean,
    default: false
  },
  clearable: {
    type: Boolean,
    default: false
  },
  placeholder: {
    type: String,
    default: ''
  },
  errorMessage: {
    type: String,
    default: undefined
  },
  errorMessages: {
    type: Array,
    default: () => undefined
  }
}

export default props

export const extractProps = (allProps) => {
  let extractedProps = {}

  for (let [key] of Object.entries(props)) {
    extractedProps[key] = allProps[key]
  }

  return extractedProps
}
